import JsonRPCService from './JsonRPCService';

export default angular.module('edge.platform.jsonrpc', ['gw-portals-transport-angular'])
    .factory('JsonRPCService', JsonRPCService);